'use strict';

$(document).ready(function(){

    //Показ изображение в блоке down
    $('.down__link').on('click', function () {
        $('.down__img').slideToggle();
    });

    // Работа блока вопросов
    $('.questions__box').on('click', function () {
        $(this).toggleClass('questions__box--active');
        $(this).find('.questions__plus-vertical').toggleClass('questions__plus-vertical--active');
        $(this).parent('.questions__item').find('.questions__answer').slideToggle();
    });

    //Получение текущей даты
    // const todayDateNode = $('.unit-cost__today-date');
    // const date = new Date();
    // const currentDate = date.toLocaleDateString(); //Получаем дату формата дд.мм.гггг
    // const currentDateArray = currentDate.split('.'); //Разбиваем дату на массив
    // const currentYear = currentDateArray[2].slice(-2); //Получаем две последние цифры года
    // let currentDateSlice = currentDateArray.slice(0, -1); //Удалем год из массива даты

    // currentDateSlice.push(currentYear); //Добавляем сокращенный гд в массив даты

    // const todayDate = currentDateSlice.join('.'); //Собираем все обратно в строку формата дд.мм.гг

    // todayDateNode.text(todayDate); //Добавляем дату в нужное поле
	if($('.js-note-block-icon').length > 0){
		tooltipPosition($('.js-note-block-icon'))
		$('.js-note-block-icon').on('mouseenter', function(){
			tooltipPosition($(this))
		})
		$( window ).on('resize', function (){
			tooltipPosition($('.js-note-block-icon'))
		})
	}


	const portfolioPage = window.location.href.split("/").pop();
	if(portfolioPage === 'investments-in-yuan' || portfolioPage === 'currency-perspective') {
		$('.js-footer-text-hide').each(function(){
			$(this).hide()
		})
	}
});

function tooltipPosition(element){
	let leftSide = element[0].getBoundingClientRect().left
	let parentLeft = element[0].closest('.note-block').getBoundingClientRect().left
	let parentTop = element[0].closest('.note-block').getBoundingClientRect().top
	if($(window).width() > 480){
		if((leftSide - 250) > parentLeft){
			$('.js-note-block-message').css('left', ((leftSide - parentLeft) - 270) + 'px')
		}
		else {
			$('.js-note-block-message').css('left', ((leftSide - parentLeft) + 35) + 'px')

		}
	}
	else{
		$('.js-note-block-message').css('left', '20px')
	}
	$('.js-note-block-message').css('top', ((element[0].getBoundingClientRect().top - parentTop) + 20) + 'px')
}

